module.exports = __webpack_public_path__ + "img/cropwise-seedselector-log.c1f88873.png";